import {
  ApproveChargesSummary_Quantity,
  ApproveChargesSummary_Read,
  OrderUnitOfMeasure,
} from '@treadinc/horizon-api-spec';

import { toDecimal } from '~utils/decimal';

export class ApproveChargesSummaryQuantity {
  constructor(
    private _unit_of_measure: OrderUnitOfMeasure,
    private _quantity: number,
  ) {}

  public static parse(proto: ApproveChargesSummary_Quantity) {
    return new ApproveChargesSummaryQuantity(
      proto.unit_of_measure,
      toDecimal(proto.quantity).toNumber(),
    );
  }

  public get quantity() {
    return this._quantity;
  }

  public get unitOfMeasure() {
    return this._unit_of_measure;
  }
}

export class ApproveChargesSummary {
  constructor(
    private _receivable_total: number,
    private _payable_total: number,
    private _jobs_count: number,
    private _loads_count: number,
    private _missing_tickets_count: number,
    private _tons: number,
    private _quantities: ApproveChargesSummaryQuantity[],
  ) {}

  public static parse(proto: ApproveChargesSummary_Read) {
    return new ApproveChargesSummary(
      toDecimal(proto.receivable_total).toNumber(),
      toDecimal(proto.payable_total).toNumber(),
      proto.jobs_count,
      proto.loads_count,
      proto.missing_tickets_count,
      toDecimal(proto.tons).toNumber(),
      proto.quantities.map(ApproveChargesSummaryQuantity.parse),
    );
  }

  public get jobsCount() {
    return this._jobs_count;
  }

  public get loadsCount() {
    return this._loads_count;
  }

  public get missingTicketsCount() {
    return this._missing_tickets_count;
  }

  public get payableTotal() {
    return this._payable_total;
  }

  public get quantities() {
    return this._quantities;
  }

  public get receivableTotal() {
    return this._receivable_total;
  }

  public get tons() {
    return this._tons;
  }
}
